import { HttpClient } from '../../common/HttpClient'
import { Environment } from '../../enviroment/AppSettings'
import { ConsentFetchModel, ConsentType, IGlobalConfigurationFetchModel } from './SettingsServiceModels'

//#region SettingService Instance
let instance: SettingService
//#endregion


export class SettingService{
    private readonly _client: HttpClient;
    private readonly _consentUrlPath = "/settings/consent";
    private readonly _globalConfigUrlPath = "/settings/globalConfig"; 
  
    constructor() {
        if (instance) { //SINGLETON DESIGN PATTERN
           throw new Error("New instance cannot be created!!");
        }
     
        instance = this;
        this._client = new HttpClient(Environment.apiUrl);
    }

    public async getConsents(consentType: ConsentType): Promise<ConsentFetchModel> {
      const consentsSearchParams = new URLSearchParams({ type: consentType.toString() })
      const getConsentsWithTypeUrl = `${this._consentUrlPath}?${consentsSearchParams.toString()}`

      return (await this._client.get<ConsentFetchModel>(getConsentsWithTypeUrl)).data;
    }

    public async getGlobalConfig() : Promise<IGlobalConfigurationFetchModel>{
      return (await this._client.get<IGlobalConfigurationFetchModel>(this._globalConfigUrlPath)).data;
    }
}

let settingsService = Object.freeze(new SettingService())//SINGLETON DESIGN PATTERN
export default settingsService;